import { render } from "./SearchDropdown.vue?vue&type=template&id=64618f34&scoped=true"
import script from "./SearchDropdown.vue?vue&type=script&lang=js"
export * from "./SearchDropdown.vue?vue&type=script&lang=js"

import "./SearchDropdown.vue?vue&type=style&index=0&id=64618f34&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64618f34"]])

export default __exports__